import { BaseDto } from '@/shared/dtos/base-dto';
import { calendario_laboral_dia } from './calendario_laboral_dia';

export class calendario_laboral extends BaseDto {
    public id_usuario !: number;
    public dias_festivos !: calendario_laboral_dia[];
 } 
